import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-0 mb-2 text-center text-sm tracking-tight text-gray-900 font-ivymode" }
const _hoisted_2 = {
  key: 0,
  class: "m-0 mb-8 text-center text-xs font-medium text-parameter-title"
}
const _hoisted_3 = { class: "flex flex-col gap-3" }

import AppModal from "@/components/appModal.vue";

/**
 * Remove group confirmation modal
 *
 * Shared confirmation modal used wherever a groove or a stone group can be removed
 * (itemV3Grooves.vue, itemV3StonesList.vue, itemV3Stones.vue). The parent component
 * keeps track of which group/groove is pending removal and only decides what to do
 * once the "confirm" event is emitted - this component only owns the visibility
 * (v-model) and the confirm/cancel UI.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3RemoveGroupModal',
  props: {
    modelValue: { type: Boolean },
    itemName: { default: "" }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const emit = __emit;

const close = () => emit("update:modelValue", false);

const handleConfirm = () => {
  emit("confirm");
  close();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    "model-value": props.modelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', $event))),
    label: _ctx.$t('components.itemV2.itemV2Main.remove_feature_confirm_title')
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "fade-fast" }, {
        default: _withCtx(() => [
          (props.modelValue)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/40 backdrop-blur-sm p-6",
                onClick: close
              }, [
                _createElementVNode("div", {
                  class: "w-full max-w-sm rounded-2xl border border-white/70 bg-parameter-box-bg p-8 shadow-[0_1px_3px_rgba(68,68,68,0.06)] animate-scale-in",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-6 flex items-center justify-center" }, [
                    _createElementVNode("div", { class: "flex size-16 items-center justify-center rounded-full bg-brand-main/10 text-brand-main" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-8 w-8",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                        _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('components.itemV2.itemV2Main.remove_feature_confirm_title')), 1),
                  _createElementVNode("p", {
                    class: _normalizeClass(["m-0 text-center text-[10px] leading-[15px] font-normal tracking-[0.1px] text-parameter-text", __props.itemName ? 'mb-2' : 'mb-8'])
                  }, _toDisplayString(_ctx.$t('components.itemV2.itemV2Main.remove_feature_confirm_text')), 3),
                  (__props.itemName)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.itemName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleConfirm,
                      class: "w-full cursor-pointer rounded-2xl bg-brand-main py-3.5 text-xs font-medium text-white transition-all hover:bg-brand-main/90 active:scale-95"
                    }, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.confirm')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: close,
                      class: "w-full cursor-pointer rounded-2xl bg-[#f3f0e9] py-3.5 text-xs font-medium text-parameter-text transition-all hover:bg-[#e7ddcc] hover:text-parameter-title active:scale-95"
                    }, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.cancel')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "label"]))
}
}

})